{
  "prod": {
    "urls": [
      "https://infoportal.csob.sk"
    ],
    "apiUrl": null,
    "keycloak": {
      "config": {
        "url": "https://prihlasenie.csobpoistovna.sk/auth",
        "realm": "Infoportal",
        "clientId": "infoportal-pkce"
      },
      "initOptions": {
        "checkLoginIframe": false
      }
    }
  },
  "acc": {
    "urls": [
      "https://infoportal-pilot.csob.sk",
      "https://infoportal-acc.csob.sk"
    ],
    "apiUrl": null,
    "keycloak": {
      "config": {
        "url": "https://prihlasenieacc.csobpoistovna.sk/auth",
        "realm": "Infoportal",
        "clientId": "infoportal-pkce"
      },
      "initOptions": {
        "checkLoginIframe": false
      }
    }
  },
  "local": {
    "urls": [
      "http://localhost:4200"
    ],
    "apiUrl": "http://localhost:8120/infoportal",
    "keycloak": {
      "config": {
        "url": "http://localhost:8280/auth",
        "realm": "Infoportal",
        "clientId": "infoportal-pkce"
      },
      "initOptions": {
        "checkLoginIframe": false
      }
    }
  }
}
